import React from 'react';
import './HomePage.css';
import ImageSlideShow from '../Utils/ImageSlideShow';
import PropertySearchBar from '../Utils/PropertySearchBar';
import HeaderMenu from '../Utils/Header';
import Footer from '../Utils/Footer';
import RouteTracker from '../Utils/RouteTracker';

const HomePage = () => {
  return (
    <>
      <HeaderMenu />
      <RouteTracker />
      <div className="HomePage">
        <main className="main-content">
          <div className="slideshow-container">
            <ImageSlideShow />
            <div className="overlay-content">
              <PropertySearchBar />
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default HomePage;
